import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { getSlotsForms, putSlotsForms } from '../../api/slotsForms'
import useApiCall from '../../api/useApiCall'
import LoadingSection from '../LoadingSection/LoadingSection'
import MonacoSection from '../MonacoSection/MonacoSection'

import styles from './slots-forms.module.scss'

function SlotsForms() {
    const { t } = useTranslation()

    const [{ data, loading }] = useApiCall(getSlotsForms)

    const saveChanges = async (data: string) => {
        await putSlotsForms(data).catch(() => {
            toast(t('save_error') as string)
            throw new Error()
        })
    }

    return (
        <main className={styles.slotsForms}>
            {loading ? (
                <LoadingSection />
            ) : (
                <MonacoSection
                    title="slots_and_forms.yml"
                    value={data || ''}
                    handleSave={saveChanges}
                    rawData={data || ''}
                />
            )}
        </main>
    )
}

export default SlotsForms
